import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {EndComponent} from "./pages/end/end.component";
import {FormComponent} from "./pages/form/form.component";
import {ContainerComponent} from "./pages/container/container.component";
import {HomeComponent} from "./pages/home/home.component";

const routes: Routes = [
  {
    path: '',
    component: ContainerComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      { path: 'home', component: HomeComponent },
      { path: 'form', component: FormComponent },
      { path: 'end', component: EndComponent },
    ],
  },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
